import { render } from "./GridDemo.vue?vue&type=template&id=ae52e990"
import script from "./GridDemo.vue?vue&type=script&lang=js"
export * from "./GridDemo.vue?vue&type=script&lang=js"

import "./GridDemo.vue?vue&type=style&index=0&id=ae52e990&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__